import { render, staticRenderFns } from "./CbsAppNavbarVerticalLayout.vue?vue&type=template&id=136f3f10"
import script from "./CbsAppNavbarVerticalLayout.vue?vue&type=script&lang=js"
export * from "./CbsAppNavbarVerticalLayout.vue?vue&type=script&lang=js"
import style0 from "./CbsAppNavbarVerticalLayout.vue?vue&type=style&index=0&id=136f3f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports